import winController from './winController';
import { gsap } from 'gsap';

export default class BigWinController extends winController {
  constructor(props) {
    super(props);
    this._moveCounterDuration = 3;
    // this._scaleCounterDuration = 3;
    this._moveCounterValue = 140;
    // this._scaleCounterValue = 1.3;

    this._tweens = [];
  }

  onStart() {
    this._tweens.push(
      gsap.to(this.counter, { y: `+=${this._moveCounterValue}`, duration: this._moveCounterDuration, ease: 'power4.out' }),
      // gsap.to(this.counter.scale, {
      //   x: this._scaleCounterValue,
      //   y: this._scaleCounterValue,
      //   duration: this._scaleCounterDuration
      // }));
    );

    this.ControllerPopup.showOverlay(1000);
    this.ControllerPopup.stopMainBackgroundSound();

    this._dirty = true;
  }

  onSkip() {
    this.onStart();
  }

  cleanup() {
    super.cleanup();
    if (!this._dirty) return;

    this._tweens.forEach(tween => tween.kill());
    this._tweens = [];
    this.counter.y = 0;
    // this.counter.scale.set(1);

    this.ControllerPopup.playMainBackgroundSound();
    this._dirty = false;
  }
}
